document.addEventListener('DOMContentLoaded', () => {
  const FOUNDER_VARIANT_ID = 46077718397063; // your fee variant ID
  const DELIVERY_PROP = 'Delivery Method';
  const DELIVERY_VALUE = 'Deliver By Founder';

  // ========== 1. CLICK (works on product page + homepage popup) ==========
  // Event delegation = catches buttons added later (quick-add modal)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[id^="DeliverByFounder-"]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding…';

    // Find the form near this button (works in modal + product page)
    let form = btn.closest('form') ||
               btn.closest('product-form-component')?.querySelector('form') ||
               document.querySelector(`#BuyButtons-ProductForm-${btn.dataset.sectionId}`);

    // Fallback: any product form inside the same modal/dialog
    if (!form) {
      const modal = btn.closest('dialog, [role="dialog"], .quick-add, quick-add-modal, product-form-component');
      if (modal) {
        form = modal.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
      }
    }

    if (!form) {
      alert('Product form not found');
      btn.disabled = false;
      btn.textContent = originalText;
      return;
    }

    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]') || { value: 1 };
    const productVariantId = variantInput?.value;
    const quantity = parseInt(quantityInput.value, 10) || 1;

    if (!productVariantId) {
      alert('Please select a variant');
      btn.disabled = false;
      btn.textContent = originalText;
      return;
    }

    try {
      const cart = await getCart();
      const feeAlready = cart.items.some(i => i.variant_id === FOUNDER_VARIANT_ID);

      const items = [{
        id: Number(productVariantId),
        quantity: quantity,
        properties: { [DELIVERY_PROP]: DELIVERY_VALUE }
      }];

      if (!feeAlready) {
        items.push({
          id: FOUNDER_VARIANT_ID,
          quantity: 1,
          properties: { [DELIVERY_PROP]: DELIVERY_VALUE }
        });
      }

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { [DELIVERY_PROP]: DELIVERY_VALUE }
        })
      });

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      window.location.href = '/checkout';

    } catch (err) {
      console.error(err);
      alert(err.message || 'Something went wrong');
      btn.disabled = false;
      btn.textContent = originalText;
    }
  });

  // ========== 2. AUTO-CLEAR FEE WHEN IT IS LEFT ALONE ==========
  let isClearing = false;

  async function clearFeeIfAlone() {
    if (isClearing) return;
    try {
      const cart = await getCart();
      const feeItems = cart.items.filter(i => i.variant_id === FOUNDER_VARIANT_ID);
      const otherItems = cart.items.filter(i => i.variant_id !== FOUNDER_VARIANT_ID);

      if (feeItems.length > 0 && otherItems.length === 0) {
        isClearing = true;
        await fetch('/cart/clear.js', { method: 'POST' });
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [DELIVERY_PROP]: '' } })
        });
        window.location.reload();
      }
    } catch (err) {
      console.error('clearFeeIfAlone error:', err);
    }
  }

  setInterval(clearFeeIfAlone, 1500);

  // ========== HELPERS ==========
  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }
});